// components/MyPage/NotificationsPanel.jsx
import { useState, useEffect } from 'react';
import {
    Box, Tabs, Tab, Divider, useMediaQuery
} from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';

import Timeline from './Timeline';
import NotificationSettings from './NotificationSettings';

export default function NotificationsPanel() {
    const [tab, setTab] = useState(0);
    const location = useLocation();

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const tabParam = params.get('tab');
        if (tabParam === 'timeline') setTab(0);
        if (tabParam === 'settings') setTab(1);
    }, [location.search]);

    const GUTTER = isMobile ? 2 : 3;  // 모바일은 px 16, PC는 px 24

    return (
        <Box sx={{ px: GUTTER }}>
            <Tabs
                value={tab}
                onChange={(_, v) => setTab(v)}
                variant={isMobile ? 'fullWidth' : 'standard'}
                size={isMobile ? 'small' : 'medium'}
                sx={{
                    mb: 2,
                    '.MuiTab-root': {
                        minHeight: isMobile ? 36 : undefined,
                        fontSize: isMobile ? '0.85rem' : undefined,
                    },
                }}
            >
                <Tab label="새 소식" />
                <Tab label="알림 설정" />
            </Tabs>

            <Divider sx={{ mb: 2 }} />

            {tab === 0 && <Timeline gutter={GUTTER} />}
            {tab === 1 && (
                <Box sx={{ '& h6': { display: 'none' } }}>
                    <NotificationSettings />
                </Box>
            )}
        </Box>
    );
}